
(function () {
  const OZB_CODE = 'OZB10';

  function formatMoney(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + (((Number(cents) || 0) / 100).toFixed(2));
    }
  }

  function getOzbApplication(cart) {
    const applications = (cart && cart.cart_level_discount_applications) || [];
    const direct = applications.find(function (discount) {
      const title = String(discount && discount.title || '').toUpperCase();
      return title.indexOf('OZB10') !== -1 || title.indexOf('OZBARGAIN') !== -1;
    });
    if (direct) return direct;

    const base = Number(cart && (cart.items_subtotal_price || cart.original_total_price) || 0);
    const actual = Number(cart && cart.total_discount || 0);
    const expected = Math.round(base * 0.28);

    if (base >= 20000 && actual > 0 && Math.abs(actual - expected) <= 2) {
      return { title: OZB_CODE, total_allocated_amount: actual };
    }
    return null;
  }

  function breakdownMarkup(base, totalSaving) {
    const normal20 = Math.round(base * 0.20);
    const ozbExtra = Math.max(0, totalSaving - normal20);

    return [
      '<div class="cart_notification--discount mb-20" data-rp-ozb-breakdown="true">',
      '<ul class="discounts list-unstyled" role="list" aria-label="Discounts">',
      '<li class="discounts__discount d-flex justify-content-between">',
      '<span class="discount__title">20% site-wide discount</span>',
      '<span class="discount__amount">(-' + formatMoney(normal20) + ')</span>',
      '</li>',
      '<li class="discounts__discount d-flex justify-content-between">',
      '<span class="discount__title">OZB10 extra 10%</span>',
      '<span class="discount__amount">(-' + formatMoney(ozbExtra) + ')</span>',
      '</li>',
      '<li class="discounts__discount d-flex justify-content-between" style="font-weight:700;margin-top:6px;">',
      '<span class="discount__title">Total savings (28%)</span>',
      '<span class="discount__amount">(-' + formatMoney(totalSaving) + ')</span>',
      '</li>',
      '</ul>',
      '<small style="display:block;margin-top:5px;opacity:.8;">The extra 10% is applied after the normal 20% discount.</small>',
      '</div>'
    ].join('');
  }

  function renderOzbBreakdown(cart) {
    const app = getOzbApplication(cart);
    if (!app) return false;

    const base = Number(cart.items_subtotal_price || cart.original_total_price || 0);
    const totalSaving = Number(app.total_allocated_amount || cart.total_discount || Math.round(base * 0.28));
    const markup = breakdownMarkup(base, totalSaving);

    const drawerDiscount = document.getElementById('cart-notification-discount');
    if (drawerDiscount) drawerDiscount.innerHTML = markup;

    const drawerSubtotal = document.getElementById('cart-notification-subtotal');
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) {
      const totalValue = cartFooter.querySelector('.totals__subtotal-value');
      if (totalValue) totalValue.textContent = formatMoney(cart.total_price);

      const existingDiscounts = cartFooter.querySelector('.discounts');
      if (existingDiscounts && existingDiscounts.closest('div')) {
        existingDiscounts.closest('div').style.display = 'none';
      }

      let custom = cartFooter.querySelector('#rp-cart-ozb-breakdown');
      if (!custom) {
        custom = document.createElement('div');
        custom.id = 'rp-cart-ozb-breakdown';
        const totals = cartFooter.querySelector('.totals');
        if (totals) totals.insertAdjacentElement('afterend', custom);
      }
      if (custom) custom.innerHTML = markup;
    }

    document.querySelectorAll('#coupon_code, #coupon_code_cart').forEach(function (input) {
      input.value = OZB_CODE;
    });

    return true;
  }

  function showCouponError(errorEl, message) {
    if (!errorEl) return;
    if (message) errorEl.textContent = message;
    errorEl.classList.remove('no-js-inline');
  }

  function hideCouponError(errorEl) {
    if (errorEl) errorEl.classList.add('no-js-inline');
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh cart');
    return response.json();
  }

  async function applyDiscountCode(rawCode, button, errorEl) {
    const code = String(rawCode || '').trim();

    if (!code) {
      showCouponError(errorEl, 'Please enter a discount code.');
      return false;
    }

    if (button) button.classList.add('loading');
    hideCouponError(errorEl);

    try {
      const response = await fetch(routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      });

      if (!response.ok) throw new Error('Discount could not be applied');

      const cart = await fetchCart();
      const upperCode = code.toUpperCase();

      if (upperCode === OZB_CODE) {
        const app = getOzbApplication(cart);
        if (!app) {
          localStorage.removeItem('coupon');
          const base = Number(cart.items_subtotal_price || cart.original_total_price || 0);
          if (base < 20000) {
            showCouponError(errorEl, 'OZB10 requires a minimum $200 order.');
          } else {
            showCouponError(errorEl, 'OZB10 could not be applied. Please check the code and try again.');
          }
          return false;
        }

        localStorage.setItem('coupon', OZB_CODE);
        renderOzbBreakdown(cart);
        return true;
      }

      localStorage.setItem('coupon', code);
      window.location.reload();
      return true;
    } catch (error) {
      console.error(error);
      showCouponError(errorEl, 'Discount could not be applied. Please try again.');
      return false;
    } finally {
      if (button) button.classList.remove('loading');
    }
  }

  async function refreshOzbDisplay() {
    if (String(localStorage.getItem('coupon') || '').toUpperCase() !== OZB_CODE) return;
    try {
      const cart = await fetchCart();
      renderOzbBreakdown(cart);
    } catch (error) {
      console.error(error);
    }
  }

  function setupCartPageCoupon() {
    const input = document.getElementById('coupon_code_cart');
    if (!input || document.getElementById('rp-coupon-apply-cart')) return;

    const saved = localStorage.getItem('coupon');
    if (saved) input.value = saved;

    const button = document.createElement('button');
    button.type = 'button';
    button.id = 'rp-coupon-apply-cart';
    button.className = 'button button--primary';
    button.textContent = 'Apply';
    button.style.marginTop = '10px';

    const message = document.createElement('div');
    message.className = 'coupon_wrong_message error no-js-inline mt-15';
    message.id = 'rp-cart-coupon-message';

    input.insertAdjacentElement('afterend', button);
    button.insertAdjacentElement('afterend', message);

    async function applyFromCartPage() {
      const ok = await applyDiscountCode(input.value, button, message);
      if (ok && String(input.value || '').trim().toUpperCase() === OZB_CODE) {
        hideCouponError(message);
      }
    }

    button.addEventListener('click', applyFromCartPage);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyFromCartPage();
      }
    });
  }

  function observeCartDrawer() {
    const target = document.getElementById('cart-notification-discount');
    if (!target || target.dataset.rpObserverAttached === 'true') return;
    target.dataset.rpObserverAttached = 'true';

    let timer;
    new MutationObserver(function () {
      if (String(localStorage.getItem('coupon') || '').toUpperCase() !== OZB_CODE) return;
      if (target.querySelector('[data-rp-ozb-breakdown="true"]')) return;
      clearTimeout(timer);
      timer = setTimeout(refreshOzbDisplay, 40);
    }).observe(target, { childList: true, subtree: true });
  }

  window.RPDiscountUI = {
    applyDiscountCode: applyDiscountCode,
    refresh: refreshOzbDisplay,
    render: renderOzbBreakdown
  };

  document.addEventListener('DOMContentLoaded', function () {
    setupCartPageCoupon();
    observeCartDrawer();

    const saved = localStorage.getItem('coupon');
    if (saved) {
      document.querySelectorAll('#coupon_code, #coupon_code_cart').forEach(function (input) {
        input.value = saved;
      });
    }

    refreshOzbDisplay();
  });
})();

theme.CartDrawerActions = function () {
  let cartActionsButtons = document.querySelectorAll('.cart_notification_action_button'),
      cartCancelButtons = document.querySelectorAll('.action_drawer_footer .button__cancel'),
      cartSaveButtons = document.querySelectorAll('.action_drawer_footer .button__save'),
      cartNoteData = document.getElementById('cartNote'),
      actionOverlay = document.querySelector('.cart_action_drawer_overlay'),
      cartNote = document.getElementById('cart_note_drawer'),
      ShippingCalc = document.getElementById('shipping_drawer'),
      couponDrawer = document.getElementById('coupon_drawer'),
      shippingCountry = document.getElementById('AddressCountry_Shipping'),
      countryState = document.getElementById('AddressProvince_shipping'),
      shippingCountryZip = document.getElementById('ShippingAddressZip');

  fetch('/cart.js')
    .then(response => response.json())
    .then(json => {
      if (cartNoteData) cartNoteData.value = json.note || '';
      if (window.RPDiscountUI) window.RPDiscountUI.render(json);
    })
    .catch(err => console.log(err));

  cartActionsButtons.forEach(item => {
    item.addEventListener('click', () => {
      if ('note' === item.dataset.drawer) {
        cartNote.classList.add('active');
        actionOverlay.classList.add('active');
      } else if ('shipping' === item.dataset.drawer) {
        ShippingCalc.classList.add('active');
        actionOverlay.classList.add('active');
      } else {
        const saved = localStorage.getItem('coupon');
        const couponInput = document.getElementById('coupon_code');
        if (saved && couponInput) couponInput.value = saved;
        couponDrawer.classList.add('active');
        actionOverlay.classList.add('active');
      }
    });
  });

  cartCancelButtons.forEach(item => {
    item.addEventListener('click', () => {
      if ('note' === item.dataset.action) {
        cartNote.classList.remove('active');
        actionOverlay.classList.remove('active');
      } else if ('shipping' === item.dataset.action) {
        ShippingCalc.classList.remove('active');
        actionOverlay.classList.remove('active');
      } else {
        couponDrawer.classList.remove('active');
        actionOverlay.classList.remove('active');
      }
    });
  });

  cartSaveButtons.forEach(item => {
    item.addEventListener('click', async () => {
      if ('note' === item.dataset.action) {
        let noteUpdate = cartNoteData.value;
        item.classList.add('loading');
        let body = JSON.stringify({ note: noteUpdate });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then(response => response.json())
          .then(() => {
            cartNote.classList.remove('active');
            actionOverlay.classList.remove('active');
            item.classList.remove('loading');
          })
          .catch(e => console.error(e));
      }

      if ('shipping' === item.dataset.action) {
        let shippingRatePackage = document.querySelector('.shipping_rate_package'),
            shippingAddressWrapper = document.querySelector('.shipping_rate_message'),
            shippingAddressCount = document.querySelector('.shipping_address_count');

        shippingRatePackage.innerHTML = '';

        if ('---' !== shippingCountry.value) {
          item.classList.add('loading');
          fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState.value}`)
            .then(response => {
              if (response.ok) return response.json();
              throw `${window.shipping.wrong_message}`;
            })
            .then(response => {
              item.classList.remove('loading');
              shippingAddressWrapper.classList.remove('no-js-inline');
              shippingAddressCount.innerText = `${response.shipping_rates.length}`;
              response.shipping_rates.map(rate => {
                let text = document.createElement('P');
                text.setAttribute('class', 'mb-0');
                text.innerText = `${rate.name}: ${shopCurrencySymbol}${rate.price}`;
                shippingRatePackage.appendChild(text);
              });
            })
            .catch(e => {
              item.classList.remove('loading');
              shippingAddressWrapper.classList.add('no-js-inline');
              shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
            });
        } else {
          shippingAddressWrapper.classList.add('no-js-inline');
          shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
        }
      }

      if ('coupon' === item.dataset.action) {
        let wrongMessage = document.querySelector('#coupon_drawer .coupon_wrong_message'),
            couponCode = document.getElementById('coupon_code').value;

        const applied = await window.RPDiscountUI.applyDiscountCode(couponCode, item, wrongMessage);
        if (applied) {
          couponDrawer.classList.remove('active');
          actionOverlay.classList.remove('active');
          if (wrongMessage) wrongMessage.classList.add('no-js-inline');
        }
      }
    });
  });

  Shopify && Shopify.CountryProvinceSelector &&
    new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
      hideElement: 'AddressProvinceContainerNewShiping'
    });
};
